
    <ingo-mobile-app-modal
        (onOpenApp)="openApp()"
        (onDismiss)="dismiss()"
        (onStopShowing)="stopShowingThisModal()">
    </ingo-mobile-app-modal>